import "./button1.css";


function Button1 (props: {text: string, color: string, height: number, width: number, onClickFunction: () => void}) {

    return (
        <button 
            style={{backgroundColor: props.color, height: props.height + "rem", width: props.width + "rem", borderRadius: (props.height / 2) + "rem"}} 
            className="button1" 
            onClick={props.onClickFunction}
            type="button"
        >
            {props.text}
        </button>
    );
}

export default Button1;